import { DestinationFaqApi } from '@model/iceberg/service/geography/destination-faq-api';
import { DestinationFaqResponse } from '@state/slices/destination-faq';

export const getDestinationFaqData = async (path: string) => {
  const api: DestinationFaqApi = new DestinationFaqApi();
  const faqs: DestinationFaqResponse = await api.getDestinationFaq({ path }).catch((error: any) => error);
  return faqs;
};
